import React from 'react';
import { palette } from '@aleohq/ui/dist/palette';

const AleoThemeContext = React.createContext({
    primaryColor: palette.blue6
});

export default AleoThemeContext;
